import { RbacPermissionsConstant } from '../../services/rbac/rbac-permissions.constant';
import { Tabs } from './tabs.interface';

const tabs: Tabs = {
  groups: {
    Incidents: {
      subTabs: [
        {
          Default: RbacPermissionsConstant.PAGES_TABLE_INCIDENTS,
        },
      ],
    },
    Notifications: {
      subTabs: [
        {
          Master: RbacPermissionsConstant.PAGES_TABLE_NOTIFICATIONS,
        },
        {
          Affiliates: RbacPermissionsConstant.PAGES_TABLE_CRM_NOTIFICATIONS,
        },
        {
          Conversions: RbacPermissionsConstant.PAGES_TABLE_CRM_NOTIFICATIONS,
        },
      ],
    },
  },
  activeTabTitle: null,
  activeSubTabTitle: null,
};

const notificationPermissions = Object.values(tabs.groups).reduce((acc, { subTabs }) => {
  return [...acc, ...subTabs.map((tab) => Object.values(tab)).map((tab) => tab[0])];
}, []);

/**
 * TODO: refac local storage
 * Need change storage key if you rename old tabs or add new tabs
 */
const localStorageTabsKey = 'notifications:tabs:v3';

export { tabs, notificationPermissions, localStorageTabsKey };
